// extracted by mini-css-extract-plugin
export var fadeInUp = "fade-in-up-module--fadeInUp--18a81";
export var inView = "fade-in-up-module--inView--04f56";